import React from "react";
import { useFormik } from "formik";
import { Modal, Button, Form } from "react-bootstrap";
import countries from "../../JSON/isoCode.json";
import { MultiSelect } from "react-multi-select-component";

const AddMasterDataWithCountryCode = ({
  formName,
  showAddForm,
  setShowAddForm,
  addMasterData,
}) => {
  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = `Please Enter ${formName} Name.`;
    } else if (!values.name.trim()) {
      errors.name = `The ${formName} Name Cannot Be Blank.`;
    } else if (values?.isoCode?.length === 0) {
      errors.isoCode = `Please Select Country Name.`;
    }
    return errors;
  };

  const handleHide = () => {
    setShowAddForm(false);
    formik.resetForm();
  };
  const formik = useFormik({
    initialValues: {
      name: "",
      isoCode: [],
    },
    validate,
    onSubmit: (values) => {
      const payload = {
        name: values.name,
        isoCode: values.isoCode,
      };
      addMasterData(payload);
      handleHide();
      values.name = "";
      values.isoCode = [];
    },
  });

  return (
    <Modal show={showAddForm} onHide={(e) => handleHide()} centered>
      <Modal.Header className="dialog-header" closeButton>
        <Modal.Title>Add {formName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group controlId="formName">
            <Form.Label>{formName} Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                isInvalid={formik.touched.name && !!formik.errors.name}
                // placeholder="Language Name"
                // className="py-2"
              />
            <Form.Control.Feedback type="invalid">
              {formik.touched.name && formik.errors.name}
            </Form.Control.Feedback>
          </Form.Group>
          <br />
          <Form.Group controlId="formCountry">
            <Form.Label>{formName} Country</Form.Label>
            <div className="card flex justify-content-center">
              <MultiSelect
                options={countries}
                value={formik.values?.isoCode}
                onChange={(selected) =>
                  formik.setFieldValue("isoCode", selected)
                }
                name="isoCode"
                labelledBy="Select Countries"
                className="w-full md:w-20rem"
              />
            </div>
            {formik.touched.isoCode && formik.errors.isoCode ? (
              <div
                className="invalid-feedback d-block"
                style={{ color: "red" }}
              >
                {formik.errors.isoCode}
              </div>
            ) : null}
          </Form.Group>
          <br />
          <Modal.Footer>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddMasterDataWithCountryCode;
